import {Component, ChangeDetectionStrategy} from "@angular/core"
import {TestCaseEntry} from "@app/test/manual-testing/helpers/configurator-test-helpers"
import {TestContainerComponent} from "@app/test/manual-testing/test-container/test-container.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-customer-pages-test",
    templateUrl: "./customer-pages-test.component.html",
    styleUrls: ["./customer-pages-test.component.scss"],
    imports: [TestContainerComponent],
})
export class CustomerPagesTestComponent {
    // Each case opens the real customer site in a new tab. Requestly redirects the
    // configurator.colormass.com web-component requests to the local dev server (see
    // the setup hint in the template), so local changes are exercised on live pages.
    private readonly redirectTooltip = "Use the requestly addon to redirect colormass.com requests to localhost."

    testCases: TestCaseEntry[] = [
        {
            type: "test",
            name: "Vado Cameo vanity builder",
            tooltip: this.redirectTooltip,
            fct: () => {
                window.open("https://www.vado.com/cameo-vanity-builder", "_blank")
            },
        },
        {
            type: "test",
            name: "Vado Safari vanity builder",
            tooltip: this.redirectTooltip,
            fct: () => {
                window.open("https://www.vado.com/safari-vanity-builder", "_blank")
            },
        },
        {
            type: "test",
            name: "Designtex digital studio",
            tooltip: this.redirectTooltip,
            fct: () => {
                window.open("https://www.designtex.com/digital-studio/", "_blank")
            },
        },
        {
            type: "test",
            name: "MyLifeBathrooms Keva floor",
            tooltip: this.redirectTooltip,
            fct: () => {
                window.open("https://mylifebathrooms.com/keva-floor/", "_blank")
            },
        },
        {
            type: "test",
            name: "Maharam Meld product page",
            tooltip: this.redirectTooltip,
            fct: () => {
                window.open("https://www.maharam.com/maharam/products/meld/colors/025-kiss", "_blank")
            },
        },
        {
            type: "test",
            name: "Delvaux MTO",
            tooltip: `${this.redirectTooltip} Password: DelvauxMTO!`,
            fct: () => {
                window.open("https://cm-delvaux-dev.web.app/", "_blank")
            },
        },
    ]
}
